import React from 'react'
import styled from 'styled-components'
import { skills } from '../../data/constants'
import ScrollReveal from '../ScrollReveal'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding-bottom: 80px;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
`

export const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`

export const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const SkillsLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 30px;
  padding: 0 16px;
`

const SkillRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const SkillRowTwoCols = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Skill = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.card};
  border: 0.1px solid ${({ theme }) => theme.primary};
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  border-radius: 16px;
  padding: 18px 36px;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 10px 36px;
  }
  @media (max-width: 500px) {
    padding: 10px 24px;
  }
`

const SkillTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 20px;
  text-align: center;
`

const SkillList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  flex: 1;
  align-content: flex-start;
`

const SkillItem = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_primary + 80};
  border: 1px solid ${({ theme }) => theme.text_primary + 80};
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 12px;
  }
  @media (max-width: 500px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`

const SkillImage = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`

const SkillCardContent = ({ category }) => (
  <Skill>
    <SkillTitle>{category.title}</SkillTitle>
    <SkillList>
      {category.skills.map((item, i) => (
        <SkillItem key={i}>
          <SkillImage src={item.image} alt={item.name} />
          {item.name}
        </SkillItem>
      ))}
    </SkillList>
  </Skill>
)

const Skills = () => {
  const frontend = skills.find((s) => s.title === 'Frontend')
  const backend = skills.find((s) => s.title === 'Backend')
  const mobile = skills.find((s) => s.title === 'Mobile')
  const tools = skills.find((s) => s.title === 'Tools & Others')

  return (
    <Container id="skills">
      <Wrapper>
        <ScrollReveal direction="up" index={0}>
          <Title>Skills</Title>
        </ScrollReveal>
        <ScrollReveal direction="up" index={1}>
          <Desc>
            Here are some of my skills on which I have been working on for the past 2 years.
          </Desc>
        </ScrollReveal>

        <SkillsLayout>
          {/* Row 1 — Frontend */}
          {frontend && (
            <SkillRow>
              <ScrollReveal direction="up" index={2} style={{ width: '100%' }}>
                <SkillCardContent category={frontend} />
              </ScrollReveal>
            </SkillRow>
          )}

          {/* Row 2 — Backend */}
          {backend && (
            <SkillRow>
              <ScrollReveal direction="up" index={3} style={{ width: '100%' }}>
                <SkillCardContent category={backend} />
              </ScrollReveal>
            </SkillRow>
          )}

          {/* Row 3 — Mobile + Tools & Others (2 columns, même height) */}
          <SkillRowTwoCols>
            {mobile && (
              <ScrollReveal direction="up" index={4} style={{ height: '100%' }}>
                <SkillCardContent category={mobile} />
              </ScrollReveal>
            )}
            {tools && (
              <ScrollReveal direction="up" index={5} style={{ height: '100%' }}>
                <SkillCardContent category={tools} />
              </ScrollReveal>
            )}
          </SkillRowTwoCols>
        </SkillsLayout>
      </Wrapper>
    </Container>
  )
}

export default Skills
